import { render } from "./StudioSegmentedPicker.vue?vue&type=template&id=b4e61d48&ts=true"
import script from "./StudioSegmentedPicker.vue?vue&type=script&lang=ts"
export * from "./StudioSegmentedPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__